module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Light.0229ea63.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/themes/fonts/SFProDisplay-Light.woff2
// module id = 337
// module chunks = 1